import React from 'react';
import { Box, AppBar, Toolbar, Button, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { HomeLayouts } from '../../components/layouts/HomeLayouts';
import logo from '../../assets/logo_name_white.png';
import { FloatingCartButton } from '../../components/CartButton';
import { CartButton } from '../../components/CartButton';

export const PublicCatalogLayout = ({ children, supplierName }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useSelector((state) => state?.auth);
  const status = auth?.status;
  const isAuthenticated = status === 'authenticated';

  const handleNavigateToLogin = () => {
    sessionStorage.setItem('redirectAfterLogin', location.pathname);
    navigate('/ingreso');
  };

  const handleNavigateToRegister = () => {
    sessionStorage.setItem('redirectAfterLogin', location.pathname);
    navigate('/registro');
  };

  if (isAuthenticated) {
    return <HomeLayouts>{children}</HomeLayouts>;
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', width: '100%' }}>
      <FloatingCartButton />
      <AppBar position="static" sx={{ backgroundColor: '#49a35b', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <Toolbar sx={{ justifyContent: 'space-between', paddingX: { xs: 2, md: 6 }, paddingY: 1 }}>
          <Box display="flex" alignItems="center">
            <img 
              src={logo} 
              alt="CADO" 
              style={{ height: '40px', marginRight: '16px' }}
            />
            {supplierName && (
              <Typography variant="h6" sx={{ color: '#fff', marginLeft: 2, marginRight: 1, display: { xs: 'none', md: 'block' } }}>
                |
              </Typography>
            )}
            {supplierName && (
              <Typography variant="h6" sx={{ color: '#fff', marginLeft: 2, fontSize: '1.3rem', display: { xs: 'none', md: 'block' } }}>
                {supplierName}
              </Typography>
            )}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <CartButton color="#fff" />
            </Box>
            <Button
              onClick={handleNavigateToLogin}
              sx={{
                color: '#fff',
                marginRight: 2,
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
              }}
            >
              Iniciar Sesión
            </Button>
            <Button
              onClick={handleNavigateToRegister}
              variant="contained"
              sx={{
                backgroundColor: '#fff',
                color: '#49a35b',
                fontWeight: 'bold',
                '&:hover': { backgroundColor: '#f0f0f0' }
              }}
            >
              Registrarse
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      
      <div style={{ flex: 1, backgroundColor: '#f8f9fa', width: '100%', boxSizing: 'border-box' }}>
        {children}
      </div>
      
      <Box
        component="footer"
        sx={{
          backgroundColor: '#49a35b',
          padding: 3,
          textAlign: 'center'
        }}
      >
        <Typography variant="body2" sx={{ color: '#fff' }}>
          © 2025 CADO.
        </Typography>
      </Box>
    </div>
  );
};
